(function () {
  var container = document.querySelector('[data-footerv2-accordion]');
  if (!container) return;

  function setHeight(block) {
    var content = block.querySelector('[data-footerv2-content]');
    if (content && window.innerWidth < 750) {
      content.style.setProperty('--footerv2-content-height', content.scrollHeight + 'px');
    }
  }

  container.addEventListener('click', function (e) {
    if (window.innerWidth >= 750) return;
    var trigger = e.target.closest('[data-footerv2-trigger]');
    if (!trigger) return;
    var block = trigger.closest('[data-footerv2-block]');
    if (!block) return;
    e.preventDefault();
    var open = block.getAttribute('data-open') === 'true';
    container.querySelectorAll('[data-footerv2-block]').forEach(function (b) {
      b.setAttribute('data-open', 'false');
      var t = b.querySelector('[data-footerv2-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      block.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      setHeight(block);
    }
  });

  function syncState() {
    var isMobile = window.innerWidth < 750;
    container.querySelectorAll('[data-footerv2-block]').forEach(function (block) {
      var trigger = block.querySelector('[data-footerv2-trigger]');
      if (!trigger) return;
      if (isMobile) {
        block.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        block.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncState);
  } else {
    syncState();
  }
  window.addEventListener('resize', syncState);
})();



document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.footerv2__newsletter-form').forEach(form => {
    const emailInput = form.querySelector('input[type="text"]');
    if (!emailInput) return;

    const shopifyError = form.querySelector('.footerv2__form-message--error');

    form.addEventListener('submit', e => {
      clearJsError(form);
      hideShopifyError(shopifyError);

      const email = emailInput.value.trim();
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      let isValid = true;

      if (!email) {
        isValid = false;
        showJsError(form, 'Please enter your email address.');
      } else if (!regex.test(email)) {
        isValid = false;
        showJsError(form, 'Please enter a valid email address.');
      }

      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    emailInput.addEventListener('input', () => {
      clearJsError(form);
      hideShopifyError(shopifyError);
    });
  });
 // Auto-hide success message after 5 seconds on successful submit
  const successMsg = document.querySelector('.footerv2__newsletter-form .footerv2__form-message--success');
  if (successMsg) {
    setTimeout(function () {
      if (successMsg && successMsg.parentNode) {
        successMsg.parentNode.removeChild(successMsg);
      }
    }, 5000);
  }

  // Clean ?customer_posted=true and #contact_form from the URL
  // Delay URL cleanup so user can still see the success state briefly
  setTimeout(function cleanNewsletterUrl() {
    try {
      const url = new URL(window.location.href);
      let changed = false;

      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        changed = true;
      }

      if (url.hash === '#contact_form') {
        url.hash = '';
        changed = true;
      }

      if (changed && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', url.toString());
      }
    } catch (e) {
      // Ignore URL API errors silently
    }
  }, 5000);
  function showJsError(form, msg) {
    if (form.querySelector('.js-error')) return;

    const p = document.createElement('p');
    p.className = 'footerv2__form-message footerv2__form-message--error js-error';
    p.textContent = msg;
    form.appendChild(p);
  }

  function clearJsError(form) {
    const err = form.querySelector('.js-error');
    if (err) err.remove();
  }

  function hideShopifyError(el) {
    if (el) el.style.display = 'none';
  }
});